<script setup lang="ts">

const { $twMerge } = useNuxtApp();

// PrimeVue components
const Accordion = defineAsyncComponent(() => import("primevue/accordion"));
const AccordionContent = defineAsyncComponent(() => import("primevue/accordioncontent"));
const AccordionHeader = defineAsyncComponent(() => import("primevue/accordionheader"));
const AccordionPanel = defineAsyncComponent(() => import("primevue/accordionpanel"));

const props = defineProps({
    Content: {
        type: Array,
        default: [],
    },
    variantTwo: {
        type: Boolean,
        default: false,
    },
    headingClass: {
        type: String,
        default: "",
    },
    startClosed: {
        type: Boolean,
        default: false,
    },
    containerClass: {
        type: String,
        default: "",
    },
    appendClass: {
        type: String,
        default: "",
    },
});
const content: any = computed(() => props.Content);
</script>

<template>
    <Accordion class="w-full" :value="props.startClosed ? [] : ['0']" multiple>
        <template v-if="props.variantTwo" #collapseicon>
            <span :class="props.variantTwo
                    ? 'text-[#4F0088] dark:text-[#AF66E4] bg-[#ECECEC] dark:bg-[#1B043B] size-12 p-3.5 rounded-full flex items-center justify-center'
                    : '!text-[#4F0088] dark:!text-[#E2BBFF] '
                ">
                <!-- <WrMinus /> -->
                <WrSVGIcon name="WrMinus" class="size-[21px]" />
            </span>
        </template>

        <template v-if="props.variantTwo" #expandicon>
            <span :class="props.variantTwo
                    ? 'text-[#4F0088] dark:text-[#AF66E4] bg-[#ECECEC] dark:bg-[#1B043B] size-12 p-3.5 rounded-full flex items-center justify-center'
                    : '!text-[#4F0088] dark:!text-[#E2BBFF] '
                ">
                <!-- <WrPlus /> -->
                <WrSVGIcon name="WrPlus" class="size-[21px]" />
            </span>
        </template>
        <div v-for="(item, index) in content" :key="index"
            class="mb-2 last:mb-0 rounded-lg border-0 p-px w-full bg-[var(--border-accordion)] dark:bg-[image:var(--border-accordion)] overflow-hidden"
            :class="containerClass">
            <div class="bg-[image:var(--bg-accordion)] rounded-lg" :class="appendClass">
                <AccordionPanel :value="index.toString()" class="mb-2 last:mb-0 rounded-lg border-0">
                    <AccordionHeader :pt="{
                        content: { class: '!bg-transparent pb-2' },
                        toggleicon: {
                            class: 'dark:!text-[#E2BBFF] shrink-0',
                        },
                    }" :class="$twMerge(
                'tracking-[0.5px] !font-semibold text-[16px] max-w-[95%] rounded-lg !bg-transparent !bg-none hover:!bg-transparent hover:!bg-none pl-5 text-left',
                props.headingClass
            )
                ">
                        {{ item.title }}</AccordionHeader>
                    <AccordionContent :pt="{ content: { class: '!bg-transparent py-3 px-5' } }"
                        class="!bg-transparent rounded-b-lg !font-normal">
                        <div class="m-0 text-left text-[15px] leading-relaxed" v-html="item.description"></div>
                    </AccordionContent>
                </AccordionPanel>
            </div>
        </div>
    </Accordion>
</template>
